import clsx from 'clsx';
import React from 'react';
import { createUseStyles } from 'react-jss';

import { media } from '../../utils/constants';
import Card from '../Card';
import Professionnal from './card/card-body/Professionnal';
import Profile from './card/card-body/Profile';
import ProfileTitle from './card/card-body/ProfileTitle';
import Company from './card/card-header/Company';
import Immatriculation from './card/card-header/Immatriculation';
import PrincipalActivity from './card/card-header/PrincipalActivity';

const useStyles = createUseStyles((theme) => ({
  card: {
    composes: 'flexRow justifyCenter stretchSelf',
  },
  items: {
    margin: -theme.spacing(1),
    [media.mdDown]: {
      margin: -theme.spacing(2),
    },
  },
  item: {
    margin: theme.spacing(1),
    [media.mdDown]: {
      flex: 1,
      alignSelf: 'stretch',
      margin: theme.spacing(2),
    },
  },
  cardHeader: {
    composes: 'flexRow spaceBetween',
    marginBottom: theme.spacing(2),
    [media.mdDown]: {
      flexDirection: 'column',
    },
  },
  cardBody: {
    composes: 'flexRow spaceBetween',
    marginTop: theme.spacing(2),
    [media.mdDown]: {
      flexDirection: 'column',
    },
  },
  divider: {
    height: theme.spacing(0.1),
    backgroundColor: 'grey',
  },
  left: {
    flex: 1,
  },
  center: {
    [media.mdUp]: {
      flex: 2.6,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  right: {
    composes: 'flexRow flex1 stretchSelf',
  },
}));

const SearchItem = ({ className, result }) => {
  const classes = useStyles();

  return (
      <Card className={clsx(classes.card, className)}>
        <div className={clsx(classes.cardHeader, classes.items)}>
          <div className={clsx(classes.left, classes.item)}>
            <Company result={result} />
          </div>
          <div className={clsx(classes.center, classes.item)}>
            <PrincipalActivity result={result} />
          </div>
          <div className={clsx(classes.right, classes.item)}>
            <Immatriculation result={result} />
          </div>
        </div>

        <div className={classes.divider} />

        <div className={clsx(classes.cardBody, classes.items)}>
          <div className={clsx(classes.left, classes.item)}>
            <Profile result={result} />
          </div>
          <div className={clsx(classes.center, classes.item)}>
            <ProfileTitle result={result} />
          </div>
          <div className={clsx(classes.right, classes.item)}>
            <Professionnal result={result} />
          </div>
        </div>
      </Card>
  );
}

export default SearchItem;